import React, { useState, memo, useRef, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { Container } from '@mui/material';

// import TagFilter from 'Modules/.common/components/TagFilter';

import './test.scss';
import {
  Grid,
  Paper,
  Grow,
  Button,
  Typography
} from '@mui/material';

const TestComponent = (props) => {
  const dispatch = useDispatch();

  const { user} = props;

  const { messages } = props.intl;
  const [ values, setValues ] = useState([]);
  const [shouldCrash, setShouldCrash] = useState(false);

  if (shouldCrash) {
    throw new Error('Manual crash test from /test to validate ErrorBoundary');
  }

  return (
    <Container maxWidth={false} style={{ height: '100%', padding: 24 }}>
      <Paper elevation={0} style={{ width: 304, padding: 24, height: 380 }}>
        <Typography variant="body2" style={{ marginBottom: 12 }}>
          Use this button to validate the global ErrorBoundary fallback.
        </Typography>
        <Button
          variant="contained"
          color="error"
          onClick={() => setShouldCrash(true)}
        >
          Crash App (Boundary Test)
        </Button>
        {/* <TagFilter
          //entity="Unit"
          label="Select a tag"
          placeholder="Type to search"
          height="calc(100vh - 150px)"
          onChange={(newItems) => {
            setValues(newItems);
          }}
          values={values}
        /> */}
      </Paper>
    </Container>
  );
};

export default injectIntl(memo(TestComponent));
